import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../config/axios';
import PageContainer from '../components/containers/PageContainer';
import {
    Button,
    FormLabel,
    Grid,
    alpha,
    FormControl,
    useTheme,
    Stack,
    Typography,
    FormControlLabel,
    Switch,
    TableCell,
    IconButton,
    TableRow,
} from '@mui/material';
import Section from '../components/ui/Section';
import ModalContainer from '../components/containers/ModalContainer';
import Loader from '../components/ui/Loader';
import Field from '../components/ui/Field';
import env from '../config/env';
import CustomTable from '../components/ui/CustomTable';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import Chip from '@mui/material/Chip';
import ZellerPayment from '../components/settings/ZellerPayment';
import BitcoinAddressCard from '../components/settings/BitcoinAddress';
import DiscountsSetting from '../components/settings/DiscountsSetting';

const Website = () => {
    const theme = useTheme();
    const [cashapp, setCashapp] = useState({});
    const [loader, setLoader] = useState(false);
    const [tlsAmount, setTlsAmount] = useState(0);
    const [tlsLoading, setTlsLoading] = useState(false);
    const [tlsBalance, setTlsBalance] = useState({});
    const [tlsTopUpInfo, setTlsTopUpInfo] = useState({});
    const [announcements, setAnnouncements] = useState([]);
    const [selectedAnnouncement, setSelectedAnnouncement] = useState({});
    const [announcementLoading, setAnnouncementLoading] = useState(false);
    const [premiumPrices, setPremiumPrices] = useState({});
    const [cashappID, setCashappID] = useState('');
    const [qr, setqr] = useState([]);

    const [showAddPricing, setShowAddPricing] = useState(false);

    const onCloseAddPricingModal = () => {
        setShowAddPricing(false);
    };
    const onOpenAddPricingModal = () => setShowAddPricing(true);
    useEffect(() => {
        readCashapp();
        readPremiumPrices();
        readAnnouncements();
        readTLSbalance();
        readFaq();
    }, []);
    const readCashapp = async () => {
        await api
            .get('/invoice/read-cashapp')
            .then((res) => {
                setCashapp(res.data.credentials);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const updateCashApp = async (e) => {
        e.preventDefault();
        setLoader(true);
        const params = new FormData();
        params.append('cashappId', cashappID);
        params.append('image', qr[0]);

        await api
            .put('/admin/update-cashapp', params)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                readCashapp();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response?.data?.message || 'Failed to update CashApp credentials');
            });
    };

    const readAnnouncements = async () => {
        await api
            .get('/announcement/read')
            .then((res) => {
                setAnnouncements(res.data.data || res.data || []);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const createAnnouncement = async (e) => {
        e.preventDefault();
        setAnnouncementLoading(true);

        const data = {
            message: e.target.message.value,
            type: e.target.type.value,
            status: e.target.status.checked,
        };

        await api
            .post('/announcement/create', data)
            .then((res) => {
                setAnnouncementLoading(false);
                readAnnouncements();
                toast.success(res.data.message);
                onCloseAddAnnouncementModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to create announcement');
                setAnnouncementLoading(false);
            });
    };

    const updateAnnouncement = async (e) => {
        e.preventDefault();
        setAnnouncementLoading(true);

        const data = {
            message: selectedAnnouncement.message,
            type: selectedAnnouncement.type,
            status: selectedAnnouncement.status,
        };

        await api
            .put(`/announcement/update/${selectedAnnouncement._id}`, data)
            .then((res) => {
                setAnnouncementLoading(false);
                toast.success(res.data.message);
                readAnnouncements();
                onCloseUpdateAnnouncementModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to update announcement');
                setAnnouncementLoading(false);
            });
    };

    const deleteAnnouncement = async (e) => {
        e.preventDefault();
        setAnnouncementLoading(true);

        await api
            .delete(`/announcement/delete/${selectedAnnouncement._id}`)
            .then((res) => {
                setAnnouncementLoading(false);
                toast.success(res.data.message);
                readAnnouncements();
                onCloseDeleteAnnouncementModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to delete announcement');
                setAnnouncementLoading(false);
            });
    };

    const toggleAnnouncementStatus = async (e) => {
        e.preventDefault();
        setAnnouncementLoading(true);

        await api
            .put(`/announcement/toggle-status/${selectedAnnouncement._id}`)
            .then((res) => {
                setAnnouncementLoading(false);
                toast.success(res.data.message);
                readAnnouncements();
                onCloseToggleStatusAnnouncementModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to toggle announcement status');
                setAnnouncementLoading(false);
            });
    };

    const readPremiumPrices = async () => {
        await api
            .get('/premium/read')
            .then((res) => {
                setPremiumPrices(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const updatePremiumPrices = async (e) => {
        e.preventDefault();

        const params = {
            price: premiumPrices.premiumPrice,
        };

        await api
            .put('/premium/update', params)
            .then((res) => {
                toast.success(res.data.message);
                readPremiumPrices();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to update premium prices');
            });
    };

    const readTLSbalance = async () => {
        await api
            .get('/admin/tls-balance')
            .then((res) => {
                setTlsBalance(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const addTLSbalance = async (e) => {
        setTlsLoading(true);
        e.preventDefault();
        const params = { tlsAmount };
        await api
            .post('/admin/tls-topup', params)
            .then((res) => {
                setTlsTopUpInfo(res.data);
                setTlsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setTlsLoading(false);
            });
    };

    useEffect(() => {
        if (Object.keys(tlsTopUpInfo).length > 0) {
            onOpenAddPricingModal();
        }
    }, [tlsTopUpInfo]);

    const onCloseButton = () => {
        setTlsTopUpInfo({});
        onCloseAddPricingModal();
    };

    const [faqs, setFaqs] = useState([]);
    const [message, setMessage] = useState('');
    const [loader2, setLoader2] = useState(false);
    const [faq, setFaq] = useState({ category: 'other' });
    const [showAddFaq, setShowAddFaq] = useState(false);

    const onCloseAddFaqModal = () => {
        setShowAddFaq(false);
    };
    const onOpenAddFaqModal = () => setShowAddFaq(true);

    const [showUpdateFaq, setShowUpdateFaq] = useState(false);

    const onCloseUpdateFaqModal = () => {
        setShowUpdateFaq(false);
    };
    const onOpenUpdateFaqModal = () => setShowUpdateFaq(true);
    const [showDeleteFaq, setShowDeleteFaq] = useState(false);

    const onCloseDeleteFaqModal = () => {
        setShowDeleteFaq(false);
    };
    const onOpenDeleteFaqModal = () => setShowDeleteFaq(true);

    // Announcement modal states
    const [showAddAnnouncement, setShowAddAnnouncement] = useState(false);

    const onCloseAddAnnouncementModal = () => {
        setShowAddAnnouncement(false);
    };
    const onOpenAddAnnouncementModal = () => setShowAddAnnouncement(true);

    const [showUpdateAnnouncement, setShowUpdateAnnouncement] = useState(false);

    const onCloseUpdateAnnouncementModal = () => {
        setShowUpdateAnnouncement(false);
    };
    const onOpenUpdateAnnouncementModal = () => setShowUpdateAnnouncement(true);

    const [showDeleteAnnouncement, setShowDeleteAnnouncement] = useState(false);

    const onCloseDeleteAnnouncementModal = () => {
        setShowDeleteAnnouncement(false);
    };
    const onOpenDeleteAnnouncementModal = () => setShowDeleteAnnouncement(true);

    const [showToggleStatusAnnouncement, setShowToggleStatusAnnouncement] = useState(false);

    const onCloseToggleStatusAnnouncementModal = () => {
        setShowToggleStatusAnnouncement(false);
    };
    const onOpenToggleStatusAnnouncementModal = () => setShowToggleStatusAnnouncement(true);

    const createFaq = async (e) => {
        e.preventDefault();
        setLoader2(true);
        const data = {
            question: e.target.question.value,
            answer: e.target.answer.value,
            category: e.target.category.value,
        };
        await api
            .post('/faq/create', data)
            .then((res) => {
                setLoader2(false);
                readFaq();
                toast.success(res.data.message);
                onCloseAddFaqModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to create FAQ');
                setLoader2(false);
            });
    };

    const updateFaq = async (e) => {
        e.preventDefault();
        setLoader2(true);
        const data = {
            question: faq.question,
            answer: faq.answer,
            category: faq.category,
        };
        await api
            .put('/faq/update/' + faq._id, data)
            .then((res) => {
                setLoader2(false);
                toast.success(res.data.message);
                readFaq();
                onCloseUpdateFaqModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to update FAQ');
                setLoader2(false);
            });
    };
    const deleteFaq = async (e) => {
        e.preventDefault();
        setLoader2(true);
        await api
            .delete('/faq/delete/' + faq._id)
            .then((res) => {
                setLoader2(false);
                toast.success(res.data.message);
                readFaq();
                onCloseDeleteFaqModal();
            })
            .catch((err) => {
                toast.error(err.response?.data?.message || 'Failed to delete FAQ');
                setLoader2(false);
            });
    };

    const readFaq = async () => {
        await api
            .get('/faq/read')
            .then((res) => {
                setFaqs(res.data.data);
                setLoader('');
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <PageContainer title="Edit Website" desc="Edit website appearance and options">
            <Grid container spacing={3}>
                <Grid item xs={12} sm={5}>
                    <Stack gap={3}>
                        <Section title="Cashapp">
                            <form
                                onSubmit={updateCashApp}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '1rem',
                                }}>
                                <Field
                                    label="Cashapp ID"
                                    id="cashappId"
                                    placeholder="Enter cashapp ID"
                                    name="cashappId"
                                    required
                                    value={cashapp?.cashappId}
                                    onChange={(e) => {
                                        setCashappID(e.target.value);
                                        setCashapp({
                                            ...cashapp,
                                            cashappId: e.target.value,
                                        });
                                    }}
                                />
                                <FormControl sx={{ height: '100%' }} fullWidth>
                                    <FormLabel sx={{ fontWeight: 600, mb: 0.6 }}>Upload CSV</FormLabel>
                                    <Button
                                        variant="outlined"
                                        component="label"
                                        sx={{
                                            height: '100%',
                                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                                            borderStyle: 'dashed',
                                        }}>
                                        {qr?.[0]?.name || '+ Upload QR Code'}

                                        <input
                                            type="file"
                                            id="qr"
                                            hidden
                                            name="qr"
                                            required
                                            onChange={(e) => setqr(e.target.files)}
                                        />
                                    </Button>
                                </FormControl>

                                <img
                                    src={env.BASE_API_URL + '/' + cashapp?.qr}
                                    alt="cashapp"
                                    style={{
                                        width: '100%',
                                        borderRadius: '3.4rem',
                                    }}
                                />

                                <Button type="submit" variant="contained">
                                    {loader ? <Loader /> : 'Update Cashapp Credentials'}
                                </Button>
                            </form>
                        </Section>
                        <ZellerPayment />
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Stack gap={3}>
                        <Section title="Add platform address">
                            <BitcoinAddressCard />
                        </Section>

                        <DiscountsSetting />

                        <Section title="The Label Store Topup">
                            <form onSubmit={addTLSbalance} className="d-flex justify-content-between align-items-end">
                                <div>
                                    <Field
                                        label="Amount"
                                        name="amount"
                                        value={tlsAmount}
                                        onChange={(e) => setTlsAmount(e.target.value)}
                                    />
                                    <Typography fontSize={18} fontWeight={600} mt={1}>
                                        Current Balance : <span>${tlsBalance.balance} </span>{' '}
                                    </Typography>
                                </div>

                                <Button variant="contained" type="submit">
                                    {tlsLoading ? <Loader /> : 'Add Balance'}
                                </Button>
                            </form>
                        </Section>
                        <Section title="Premium Price">
                            <form
                                onSubmit={updatePremiumPrices}
                                className="d-flex justify-content-between align-items-end">
                                <div>
                                    <Field
                                        label="Price"
                                        name="price"
                                        value={premiumPrices.premiumPrice}
                                        onChange={(e) =>
                                            setPremiumPrices({
                                                ...premiumPrices,
                                                premiumPrice: e.target.value,
                                            })
                                        }
                                    />
                                </div>

                                <Button variant="contained" type="submit">
                                    Save Changes
                                </Button>
                            </form>
                        </Section>
                        <CustomTable
                            loading={announcementLoading}
                            title="Announcements"
                            end={
                                <Button onClick={onOpenAddAnnouncementModal} variant="contained">
                                    Add Announcement
                                </Button>
                            }
                            fields={['#', 'MESSAGE', 'TYPE', 'STATUS', 'CREATED', 'ACTIONS']}>
                            {[...announcements]
                                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                .map((announcement, i) => (
                                    <TableRow key={announcement._id}>
                                        <TableCell>{i + 1}</TableCell>
                                        <TableCell>{announcement.message}</TableCell>
                                        <TableCell>
                                            <Chip
                                                label={announcement.type}
                                                color={
                                                    announcement.type === 'success'
                                                        ? 'success'
                                                        : announcement.type === 'error'
                                                        ? 'error'
                                                        : announcement.type === 'warning'
                                                        ? 'warning'
                                                        : 'info'
                                                }
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={announcement.status ? 'Active' : 'Inactive'}
                                                color={announcement.status ? 'success' : 'default'}
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {new Date(announcement.createdAt).toLocaleDateString()}
                                        </TableCell>
                                        <TableCell>
                                            <Stack direction="row">
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedAnnouncement(announcement);
                                                        onOpenUpdateAnnouncementModal();
                                                    }}>
                                                    <ModeEditOutlineOutlinedIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedAnnouncement(announcement);
                                                        onOpenToggleStatusAnnouncementModal();
                                                    }}>
                                                    <ToggleOnIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    onClick={() => {
                                                        setSelectedAnnouncement(announcement);
                                                        onOpenDeleteAnnouncementModal();
                                                    }}>
                                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                                </IconButton>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </CustomTable>
                        <CustomTable
                            loading={loader2}
                            title="FAQs"
                            end={
                                <Button onClick={onOpenAddFaqModal} variant="contained">
                                    Add FAQ
                                </Button>
                            }
                            fields={['#', 'QUESTION', 'ANSWER', 'CATEGORY', 'ACTIONS']}>
                            {faqs.map((faq, i) => (
                                <TableRow key={i}>
                                    <TableCell>{i + 1}</TableCell>
                                    <TableCell>{faq.question}</TableCell>
                                    <TableCell>{faq.answer}</TableCell>
                                    <TableCell>
                                        <Chip 
                                            label={faq.category || 'other'} 
                                            size="small"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Stack direction={'row'}>
                                            <IconButton
                                                onClick={() => {
                                                    setFaq({ ...faq, category: faq.category || 'other' });
                                                    onOpenUpdateFaqModal();
                                                }}>
                                                <ModeEditOutlineOutlinedIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => {
                                                    setFaq({ ...faq, category: faq.category || 'other' });
                                                    onOpenDeleteFaqModal();
                                                }}>
                                                <DeleteOutlineOutlinedIcon fontSize="small" />
                                            </IconButton>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </CustomTable>
                    </Stack>
                </Grid>
            </Grid>

            <ModalContainer open={showAddPricing} onClose={onCloseButton} hideActions title="Add The Label Store Topup">
                <div className="d-flex flex-column gap-2">
                    <div>
                        <h4 className="text-info">BTC</h4>
                        <p>
                            Address : <span className="text-info">{tlsTopUpInfo?.btc?.address}</span>
                        </p>
                    </div>
                    <div>
                        <h4 className="text-warning">LTC</h4>
                        <p>
                            Address : <span className="text-warning">{tlsTopUpInfo?.ltc?.address}</span>
                        </p>
                    </div>
                </div>
                <div className="d-flex mt-2 justify-content-end ">
                    <button className="btn btn-danger" onClick={() => onCloseButton()}>
                        Close
                    </button>
                </div>
            </ModalContainer>
            {/* Create */}
            <ModalContainer open={showAddFaq} onClose={onCloseAddFaqModal} hideActions title="Create FAQ">
                <form onSubmit={createFaq}>
                    <div className="form-group mb-3">
                        <label>Question</label>
                        <input type="text" className="form-control" name="question" required />
                    </div>
                    <div className="form-group mb-3">
                        <label>Answer</label>
                        <input type="text" className="form-control" name="answer" required />
                    </div>
                    <div className="form-group mb-3">
                        <label>Category</label>
                        <select className="form-control" name="category" defaultValue="other">
                            <option value="shipping">Shipping</option>
                            <option value="billing">Billing</option>
                            <option value="carriers">Carriers</option>
                            <option value="returns">Returns</option>
                            <option value="international">International</option>
                            <option value="other">Other</option>
                        </select>
                    </div>

                    <div className="d-flex mt-2 justify-content-end ">
                        <button 
                            type="button" 
                            className="btn btn-light mr-3" 
                            onClick={onCloseAddFaqModal}
                            disabled={loader2}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loader2}>
                            {loader2 ? <Loader /> : 'Create'}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* Update */}
            <ModalContainer open={showUpdateFaq} onClose={onCloseUpdateFaqModal} hideActions title="Update FAQ">
                <form onSubmit={updateFaq}>
                    <div className="form-group mb-3">
                        <label>Question</label>
                        <input
                            type="text"
                            className="form-control"
                            name="question"
                            value={faq.question}
                            onChange={(e) => setFaq({ ...faq, question: e.target.value })}
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>Answer</label>
                        <input
                            type="text"
                            className="form-control"
                            name="answer"
                            value={faq.answer}
                            onChange={(e) => setFaq({ ...faq, answer: e.target.value })}
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>Category</label>
                        <select 
                            className="form-control" 
                            name="category" 
                            value={faq.category || 'other'}
                            onChange={(e) => setFaq({ ...faq, category: e.target.value })}
                        >
                            <option value="shipping">Shipping</option>
                            <option value="billing">Billing</option>
                            <option value="carriers">Carriers</option>
                            <option value="returns">Returns</option>
                            <option value="international">International</option>
                            <option value="other">Other</option>
                        </select>
                    </div>

                    <div className="d-flex mt-2 justify-content-end ">
                        <button 
                            type="button" 
                            className="btn btn-light mr-3" 
                            onClick={onCloseUpdateFaqModal}
                            disabled={loader2}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loader2}>
                            {loader2 ? <Loader /> : 'Update'}
                        </button>
                    </div>
                </form>

                {message}
            </ModalContainer>

            {/* Delete */}

            <ModalContainer open={showDeleteFaq} onClose={onCloseDeleteFaqModal} hideActions title="Delete FAQ">
                <h6>Are you sure you want to delete this faq?</h6>
                <div className="d-flex mt-2 justify-content-end mt-3">
                    <button 
                        type="button" 
                        className="btn btn-light mr-3" 
                        onClick={onCloseDeleteFaqModal}
                        disabled={loader2}
                    >
                        Close
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-danger" 
                        onClick={(e) => deleteFaq(e)}
                        disabled={loader2}
                    >
                        {loader2 ? <Loader /> : 'Delete'}
                    </button>
                </div>
            </ModalContainer>

            {/* Add Announcement Modal */}
            <ModalContainer
                open={showAddAnnouncement}
                onClose={onCloseAddAnnouncementModal}
                hideActions
                title="Add Announcement">
                <form onSubmit={createAnnouncement}>
                    <div className="form-group mb-3">
                        <label>Message</label>
                        <textarea className="form-control" name="message" rows="3" required />
                    </div>
                    <div className="form-group mb-3">
                        <label>Type</label>
                        <select className="form-control" name="type" required>
                            <option value="info">Info</option>
                            <option value="warning">Warning</option>
                            <option value="success">Success</option>
                            <option value="error">Error</option>
                        </select>
                    </div>
                    <div className="form-group mb-3">
                        <FormControlLabel control={<Switch name="status" defaultChecked />} label="Active" />
                    </div>
                    <div className="d-flex mt-2 justify-content-end">
                        <button 
                            type="button" 
                            className="btn btn-light mr-3" 
                            onClick={onCloseAddAnnouncementModal}
                            disabled={announcementLoading}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={announcementLoading}>
                            {announcementLoading ? <Loader /> : 'Create'}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* Edit Announcement Modal */}
            <ModalContainer
                open={showUpdateAnnouncement}
                onClose={onCloseUpdateAnnouncementModal}
                hideActions
                title="Edit Announcement">
                <form onSubmit={updateAnnouncement}>
                    <div className="form-group mb-3">
                        <label>Message</label>
                        <textarea
                            className="form-control"
                            name="message"
                            rows="3"
                            value={selectedAnnouncement.message || ''}
                            onChange={(e) =>
                                setSelectedAnnouncement({
                                    ...selectedAnnouncement,
                                    message: e.target.value,
                                })
                            }
                            required
                        />
                    </div>
                    <div className="form-group mb-3">
                        <label>Type</label>
                        <select
                            className="form-control"
                            name="type"
                            value={selectedAnnouncement.type || 'info'}
                            onChange={(e) =>
                                setSelectedAnnouncement({
                                    ...selectedAnnouncement,
                                    type: e.target.value,
                                })
                            }
                            required>
                            <option value="info">Info</option>
                            <option value="warning">Warning</option>
                            <option value="success">Success</option>
                            <option value="error">Error</option>
                        </select>
                    </div>
                    <div className="form-group mb-3">
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={selectedAnnouncement.status || false}
                                    onChange={(e) =>
                                        setSelectedAnnouncement({
                                            ...selectedAnnouncement,
                                            status: e.target.checked,
                                        })
                                    }
                                />
                            }
                            label="Active"
                        />
                    </div>
                    <div className="d-flex mt-2 justify-content-end">
                        <button 
                            type="button" 
                            className="btn btn-light mr-3" 
                            onClick={onCloseUpdateAnnouncementModal}
                            disabled={announcementLoading}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={announcementLoading}>
                            {announcementLoading ? <Loader /> : 'Update'}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* Delete Announcement Modal */}
            <ModalContainer
                open={showDeleteAnnouncement}
                onClose={onCloseDeleteAnnouncementModal}
                hideActions
                title="Delete Announcement">
                <h6>Are you sure you want to delete this announcement?</h6>
                <p className="text-muted">{selectedAnnouncement.message}</p>
                <div className="d-flex mt-2 justify-content-end mt-3">
                    <button 
                        type="button" 
                        className="btn btn-light mr-3" 
                        onClick={onCloseDeleteAnnouncementModal}
                        disabled={announcementLoading}
                    >
                        Cancel
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-danger" 
                        onClick={deleteAnnouncement}
                        disabled={announcementLoading}
                    >
                        {announcementLoading ? <Loader /> : 'Delete'}
                    </button>
                </div>
            </ModalContainer>

            {/* Toggle Status Announcement Modal */}
            <ModalContainer
                open={showToggleStatusAnnouncement}
                onClose={onCloseToggleStatusAnnouncementModal}
                hideActions
                title="Toggle Announcement Status">
                <h6>
                    Are you sure you want to {selectedAnnouncement.status ? 'disable' : 'enable'} this announcement?
                </h6>
                <p className="text-muted">{selectedAnnouncement.message}</p>
                <div className="d-flex mt-2 justify-content-end mt-3">
                    <button 
                        type="button" 
                        className="btn btn-light mr-3" 
                        onClick={onCloseToggleStatusAnnouncementModal}
                        disabled={announcementLoading}
                    >
                        Cancel
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-primary" 
                        onClick={toggleAnnouncementStatus}
                        disabled={announcementLoading}
                    >
                        {announcementLoading ? <Loader /> : 'Confirm'}
                    </button>
                </div>
            </ModalContainer>
        </PageContainer>
    );
};

export default Website;
